module.exports = __webpack_public_path__ + "static/media/qrtc-quinton-rail-technology-centre-long-marston.98c721e8.png";